import React from "react";
import {
    MessageSquare,
    CheckCircle2,
    Bell,
    FileText,
    AlertTriangle,
    StickyNote,
} from "lucide-react";

const timelineWrapStyle = {
    border: "1px solid var(--border, #e5e7eb)",
    borderRadius: 16,
    padding: 16,
    background: "var(--card-bg, #fff)",
    display: "grid",
    gap: 12,
};

const eventRowStyle = {
    display: "grid",
    gridTemplateColumns: "18px 1fr",
    gap: 10,
    alignItems: "start",
};

const compactCardStyle = {
    border: "1px solid var(--border, #eee)",
    borderRadius: 12,
    padding: "8px 10px",
    display: "grid",
    gap: 3,
    background: "transparent",
};

const getIconAndColor = (type) => {
    switch (type) {
        case "message":
            return { icon: MessageSquare, color: "#2563eb" };
        case "attendance":
            return { icon: CheckCircle2, color: "#16a34a" };
        case "reminder":
            return { icon: Bell, color: "#d97706" };
        case "document":
            return { icon: FileText, color: "#7c3aed" };
        case "incident":
            return { icon: AlertTriangle, color: "#dc2626" };
        default:
            return { icon: StickyNote, color: "#5c4d7d" };
    }
};

const badgeStyle = (type) => ({
    display: "inline-flex",
    alignItems: "center",
    width: "fit-content",
    padding: "3px 8px",
    borderRadius: 999,
    fontSize: ".72rem",
    fontWeight: 800,
    background:
        type === "message"
            ? "#dbeafe"
            : type === "attendance"
                ? "#dcfce7"
                : type === "reminder"
                    ? "#fef3c7"
                    : type === "document"
                        ? "#ede9fe"
                        : type === "incident"
                            ? "#fee2e2"
                            : "#f3f4f6",
    color:
        type === "message"
            ? "#1d4ed8"
            : type === "attendance"
                ? "#166534"
                : type === "reminder"
                    ? "#92400e"
                    : type === "document"
                        ? "#6d28d9"
                        : type === "incident"
                            ? "#991b1b"
                            : "#374151",
});

const StudentTimeline = ({
    events = [],
    limit = 6,
    onViewAll,
}) => {
    const visibleEvents = limit ? events.slice(0, limit) : events;

    return (
        <div style={timelineWrapStyle}>
            <div style={{ display: "flex", justifyContent: "space-between", gap: 10, alignItems: "center" }}>
                <div style={{ fontWeight: 800 }}>Recent Activity</div>
                {onViewAll ? (
                    <button
                        type="button"
                        onClick={onViewAll}
                        style={{
                            border: "none",
                            background: "transparent",
                            color: "var(--accent, #5c4d7d)",
                            fontWeight: 800,
                            cursor: "pointer",
                            padding: 0,
                        }}
                    >
                        View All
                    </button>
                ) : null}
            </div>

            {!visibleEvents.length ? (
                <div style={{ color: "var(--text-secondary, #666)" }}>
                    No activity recorded for this student yet.
                </div>
            ) : (
                visibleEvents.map((event) => {
                    const { icon: Icon, color } = getIconAndColor(event.type);

                    return (
                        <div key={event.id} style={eventRowStyle}>
                            <div style={{ marginTop: 2 }}>
                                <Icon size={16} color={color} />
                            </div>

                            <div style={compactCardStyle}>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        gap: 10,
                                        flexWrap: "wrap",
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: ".78rem",
                                            color: "var(--text-secondary, #666)",
                                            fontWeight: 600,
                                        }}
                                    >
                                        {event.timeLabel}
                                    </div>
                                    <div style={badgeStyle(event.type)}>{event.typeLabel}</div>
                                </div>

                                <div style={{ fontWeight: 800, fontSize: ".92rem" }}>{event.title}</div>

                                {event.description ? (
                                    <div style={{ fontSize: ".84rem", color: "var(--text-secondary, #555)" }}>
                                        {event.description}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    );
                })
            )}
        </div>
    );
};

export default StudentTimeline;